import * as React from 'react';

import { PrimitiveTabs } from 'components';
import { useTagAction, useTagValue } from 'context';

import { TagBaseInfo } from './base-info';
import { TagSeoInfo } from './seo-info';

const TagFormTabs = () => {
  const { step = 1 } = useTagValue();
  const action = useTagAction();

  return (
    <PrimitiveTabs
      items={[
        {
          key: '1',
          label: 'اطلاعات اولیه',
          children: <TagBaseInfo />,
        },
        {
          key: '2',
          label: 'تنظیمات سئو',
          children: <TagSeoInfo />,
          disabled: step < 2,
        },
      ]}
      activeKey={step.toString()}
      onChange={activeKey => {
        action({
          type: 'UPDATE_TAG_STEP',
          payload: {
            step: +activeKey as typeof step,
          },
        });
      }}
    />
  );
};

export { TagFormTabs };
